import React from 'react'
//import Signup from './Form/Patient/Signup'
import {  SubTitle,  Info,  FormContainer,  LoginBtn,  TitleContainer,  TabPanel,  LogoImage,} from './Registration.styles'
import { useState } from 'react'
import { Box, InputAdornment,  IconButton,  TextField,  Container,  MenuItem,  Tabs,  Tab,  Typography,  Button,  Link} from '@mui/material'
import VitalSignsModel from './Model/VitalSignsModel';
import { createPatientsVitalSignsPublic } from '../../services/patients'
import { useToasts } from 'react-toast-notifications'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimeField } from '@mui/x-date-pickers/DateTimeField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useHistory } from 'react-router-dom'; 
import { useQuery } from 'react-query'
import { globalConfig } from '../../config';
import { getPatient  } from '../../services/patients'
import handleError from '../../utils/error-handler'

const SubmitVitalSigns = ({ user, loginWithRedirect }) => {
	const [vitalSigns,setVitalSigns] = useState(VitalSignsModel);
	const [collectionDate, setCollectionDate] = useState(dayjs());
	const { addToast } = useToasts();
	const history = useHistory();
// 	const [ehxPatientId, setEhxPatientId] = useState(0)
	const accessToken = `${globalConfig.serviceAccessToken}`

	const	valueChangeHandler = (e) => {
		const { name, value } = e.target;
    	setVitalSigns(prev => ({
      		...prev,      // Spread previous state
      		[name]: parseInt(value) // Update only the changed field		
		}));
	}
	const	valueChangeHandlerText = (e) => {
		const { name, value } = e.target;
    	setVitalSigns(prev => ({
      		...prev,      // Spread previous state
      		[name]: value // Update only the changed field		
		}));
	}

//     	const getPatientResultSet = useQuery(`patient:${vitalSigns.ehxPatientId}`, () => getPatient(vitalSigns.ehxPatientId), {
// 		staleTime: 60000,
// 		enabled: vitalSigns.ehxPatientId > 0,
//     	onError: (error) => {
//       		const message = handleError(error)
//       		addToast(message, {
//         	autoDismiss: true,
//         	appearance: 'error',
//       		})
//     	}
// 	})
		
	
	const submitHandler = async () => { 
	if (vitalSigns.ehxPatientId)
	{
	
		console.log('submitting the data - ' + JSON.stringify(vitalSigns));
		try
		{
			vitalSigns.createUser = vitalSigns.ehxPatientId;
			vitalSigns.createDate = new Date(collectionDate);
 			const results = createPatientsVitalSignsPublic(vitalSigns);
      		const message = 'Thank you, your data has been added.';
   			addToast(message, {
        		autoDismiss: true,
       		 	appearance: 'success',
      		})
			//get the patients phone number 
			{
				const patientInfoUrl = `${globalConfig.apiDatahubBaseURL}/ehx-patients/${vitalSigns.ehxPatientId}`;
				const patientResponse = await fetch(patientInfoUrl, {
						method: 'GET',
						mode: 'cors',
						headers: {
 							'Content-Type': 'application/json',
 							'Authorization': `Bearer ${accessToken}`
						},
				});
				if (patientResponse.ok)
				{
					const patientData = await patientResponse.json(); 
					const patientPhone = patientData.mainPhone;

			//now send a notification		

				const url = `${globalConfig.apiMainBaseURL}/twilio-was/send-vital-signs-acknowledgement`;				
				try
				{
						const response = fetch(url, {
						method: 'POST',
						mode: 'cors',
						headers: {
 							'Content-Type': 'application/json',
 							'Authorization': `Bearer ${accessToken}`
						},
						body: JSON.stringify({
	    	    	  	"patientId" : String(vitalSigns.ehxPatientId), 
		    			"fromNumber" : globalConfig.twilio.whatsAppChannelNumber,
        	  			"toNumber" : patientPhone,
          				"messagingServiceSid" : globalConfig.twilio.messagingServiceSid, 
          				"contentSid" : globalConfig.twilio.contentSid						
						}),
					});
					if (!response.ok){
						const responseData = response.json();
		
				          addToast('Communication error while adding vital signs - error code #' + responseData.code, {
    	        			appearance: 'error',
				            autoDismiss: true,
          				})
					}				
				}catch(x){
// 					console.log(x);	
				}
				
				}
				else{
				          addToast('Communication error while adding vital signs - Patient Phone Number', {
    	        			appearance: 'error',
				            autoDismiss: true,
          				})
				}
			}
		}
		catch(err)
		{
      		const message = err;
	   		addToast(message, {
    	    	autoDismiss: true,
        		appearance: 'error',
      		})
		}	
	}
	else {
      	const message = "You must enter a valid Patient Number";
   		addToast(message, {
        	autoDismiss: true,
        	appearance: 'error',
      	})
	}		
}


	
  return (
  <>
    <Container>
      <Info>
        <TitleContainer>
          <SubTitle>
        	<LogoImage />
            <br />
            Become the best version of you! Already
            have an account? &nbsp; &nbsp;
            <span>
              <LoginBtn onClick={() => loginWithRedirect()}>Login here</LoginBtn>
            </span>
            <br />
          </SubTitle>
        </TitleContainer>
      </Info>
      <br />
      <div>
      <h4>Enter Your Vital Signs &nbsp;&nbsp;<Link href="/get-patient-number"><Button variant="outlined" color="warning">How to get my Patient Number</Button></Link></h4>
      </div>
      <div>
      <TextField
      	name="ehxPatientId"
      	fullWidth
      	placeholder="Enter Your Patient Number"
      	type="number"
      	value={vitalSigns.ehxPatientId}
      	onChange={(e) => valueChangeHandler(e)}
      />
      </div>
      <br />
      <div>
      <TextField
      	name="height"
      	fullWidth
      	label="Height"
      	placeholder="Height"
      	value={vitalSigns.height}
      	type="number"
      	onChange={(e) => valueChangeHandler(e)}
      />
      </div>
       <br />
     <div>
      <TextField
      	name="weight"
      	fullWidth
      	label="Weight"
      	placeholder="Weight"
      	value={vitalSigns.weight}
      	type="number"
      	onChange={(e) => valueChangeHandler(e)}
      />
      </div>
      <br />
      <div>
      <TextField
      	name="bpSystolic"
      	fullWidth
      	label="Systolic"
      	placeholder="Systolic"
      	value={vitalSigns.bpSystolic}
      	type="number"
      	onChange={(e) => valueChangeHandler(e)}
        error={ vitalSigns.bpSystolic && (vitalSigns.bpSystolic < 60 || vitalSigns.bpSystolic > 250)}
        helperText={vitalSigns.bpSystolic &&  (vitalSigns.bpSystolic < 60 || vitalSigns.bpSystolic > 250) ? "Systolic must be between 60 - 250" : ' ' }
      />
      </div>
      <br />
      <div>
      <TextField
      	name="bpDiastolic"
      	fullWidth
      	label="Diastolic"
      	placeholder="Diastolic"
      	value={vitalSigns.bpDiastolic}
      	type="number"
      	onChange={(e) => valueChangeHandler(e)}
        error={vitalSigns.bpDiastolic && (vitalSigns.bpDiastolic < 60 || vitalSigns.bpDiastolic > 250)}
        helperText={vitalSigns.bpDiastolic && (vitalSigns.bpDiastolic < 60 || vitalSigns.bpDiastolic > 250) ? "Diastolic must be between 60 - 250" : ' ' }
      />
      </div>
      <br />
      <div>
      <TextField
      	name="pulse"
      	fullWidth
      	label="Pulse"
      	placeholder="Pulse"
      	value={vitalSigns.pulse}
      	type="number"
      	onChange={(e) => valueChangeHandler(e)}
        error={vitalSigns.pulse && (vitalSigns.pulse < 60 || vitalSigns.pulse > 120)}
        helperText={vitalSigns.pulse && (vitalSigns.pulse < 60 || vitalSigns.pulse > 120) ? "Pulse must be between 60 - 120" : ' ' }
      />
      </div>
      <br />
      <div>
      <TextField
      	name="temperature"
      	fullWidth
      	label="Temperature"
      	placeholder="Temperature"
      	value={vitalSigns.temperature}
      	type="number"
      	onChange={(e) => valueChangeHandler(e)}
      />
      </div>
      <br />
      <div>
      <TextField
      	name="sp02"
      	fullWidth
      	label="SP02"
      	placeholder="SP02"
      	value={vitalSigns.sp02}
      	type="number"
      	onChange={(e) => valueChangeHandler(e)}
      />
      </div>
      <br />
      <div>
      <TextField
      	name="bmi"
      	fullWidth
      	label="BMI"
      	placeholder="BMI"
      	value={vitalSigns.bmi}
      	type="number"
      	onChange={(e) => valueChangeHandler(e)}
      />
      </div>
     <br />
      <div>
      <TextField
      	name="notes"
      	fullWidth
      	label="Enter additional notes here for the doctor"
      	placeholder="Enter additional notes here for the doctor"
      	value={vitalSigns.notes}
      	onChange={(e) => valueChangeHandlerText(e)}
      />
      </div>
			<LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box>
				<hr />
				Collection Time
				<br />
              <DateTimeField
                id="createDate"
                label="Date Collected"
                variant="outlined"
                margin="normal"
                name="createDate"               
				value={collectionDate}
				fullWidth
				onChange={(newValue) => {setCollectionDate(newValue)}}
              />
              </Box>
              </LocalizationProvider>
      <hr />
      <Link href="#">
      	<Button 
      		variant="contained"
      		color="success"
      		onClick={submitHandler}
      	>
      		Save
      	</Button>
      </Link>
      {/*
      &nbsp;
      <Link href="/register-patient">
      	<Button 
      		variant="contained"
      		color="info"
      	>
      		register
      	</Button>
      </Link>
      &nbsp;
      <Link href="/">
      	<Button 
      		variant="contained"
      		color="warning"
      	>
      		Login
      	</Button>
      </Link>
      */}
    </Container>
    </>
  )
}


export default SubmitVitalSigns

{/*


      &nbsp;
      <Link href="#">
      	<Button 
      		variant="contained"
      		color="warning"
      	>
      		Add more health measures
      	</Button>
      </Link>
      &nbsp;
      <Link href="#">
      	<Button 
      		variant="contained"
      		color="error"
      	>
      		book an appointment
      	</Button>
      </Link>

*/}